import { ThemeProvider as NextThemesProvider } from "next-themes";
import { type ReactNode } from "react";

interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      // Disable transition on initial load to prevent flash, but enable for subsequent changes
      disableTransitionOnChange={false}
      // Sync with our inline script's storage key
      storageKey="theme"
      // Force theme application on mount to match pre-hydration state
      enableColorScheme
    >
      {children}
    </NextThemesProvider>
  );
}
